import React from 'react';
import LocalStrings from '../../assets/languages';

export default function EmptyContent(props) {
  const { image = '', tabName, title, subtitle, containerStyle } = props;

  return (
    <div className="no-content-message" style={containerStyle ?? {}}>
      <div>
        {!_.isEqual(image, '') && <img src={image} height={120} width={120} />}

        <div className="custom-text8-normal-primary">
          {_.isEmpty(tabName)
            ? title ?? ''
            : `${LocalStrings.dynamic.kNoTextLC} ${tabName} ${LocalStrings.dynamic.kFoundText}`}
        </div>

        <div className="no-content-text">
          {tabName ?? ''} {subtitle ?? ''}
        </div>
      </div>
    </div>
  );
}
